/* =============================================================================
   vp-uber-toggle.js — "Ursprung & Geschichte" aufklappbar       (01.09.2026)

   Gleiche Idee wie der Aufklapper der Kollektionsbeschreibung in
   vp-mobile.js, aber fuer genau eine Sektion und fuer Desktop UND mobil:
   der lange Text wird nach wenigen Zeilen gekappt, Text und Kontextbild
   (Unterschrift) erscheinen erst auf Klick.

   Warum nicht in vp-mobile.js: das ist die Datei fuer mobile Regeln und laeuft
   auf jeder Seite. Diese Verbesserung gilt auf beiden Breiten und nur auf
   /pages/uber — deshalb eine eigene, dort auch nur dort geladene Datei.

   Zeilenzahlen: mobil 7 (derselbe Wert wie auf den Kategorieseiten),
   Desktop 12. Auf dem Desktop bestimmt die Hoehe des Textes die Hoehe der
   ganzen Karte — das Bild daneben wird mitgestreckt. Gemessen bei 1600px:
   Sektion 1475px vorher, 1017px eingeklappt.
   ============================================================================= */
(function () {
  'use strict';

  if (window.__vpUberToggle) return;
  window.__vpUberToggle = true;

  var SUFFIX = '__media_with_text_gCPDq4';
  var LINES_MOBILE = 7;
  var LINES_DESKTOP = 12;
  var MQ = window.matchMedia('(max-width: 768px)');

  var text = null;
  var extras = [];
  var button = null;
  var label = null;
  var expanded = false;

  function collapsedHeight() {
    var lh = parseFloat(window.getComputedStyle(text).lineHeight);
    if (!lh || isNaN(lh)) lh = 22;
    return Math.round(lh * (MQ.matches ? LINES_MOBILE : LINES_DESKTOP));
  }

  function apply() {
    if (!text) return;

    if (expanded) {
      text.style.maxHeight = '';
      text.classList.remove('vp-story-text--clamped');
    } else {
      text.style.maxHeight = collapsedHeight() + 'px';
      text.classList.add('vp-story-text--clamped');
    }

    extras.forEach(function (el) {
      el.classList.toggle('vp-story-hidden', !expanded);
    });

    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    label.textContent = expanded ? 'Weniger anzeigen' : 'Mehr erfahren';
  }

  function build() {
    var section = document.querySelector('[id$="' + SUFFIX + '"]');
    if (!section) return;
    if (section.getAttribute('data-vp-story') === 'ready') return;

    var wrapper = section.querySelector('.media-with-text__content-wrapper');
    var candidate = section.querySelector('.content-text');
    if (!wrapper || !candidate) return;

    text = candidate;
    text.classList.add('vp-story-text');

    /* Was ohnehin kurz ist, wird nicht eingeklappt — sonst stuende ein Button
       unter einem Text, der gar nicht abgeschnitten ist. */
    if (text.scrollHeight <= collapsedHeight() + 8) {
      text.classList.remove('vp-story-text');
      text = null;
      return;
    }

    section.setAttribute('data-vp-story', 'ready');
    if (!text.id) text.id = 'vp-story-text';

    extras = Array.prototype.slice.call(wrapper.querySelectorAll('.context-image'));

    button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button--brutalist outlined-button vp-story-toggle';
    button.setAttribute('aria-controls', text.id);

    label = document.createElement('span');
    button.appendChild(label);

    button.addEventListener('click', function () {
      expanded = !expanded;
      apply();

      /* Beim Zuklappen schrumpft der Inhalt oberhalb des Buttons — ohne das
         hier springt die Seite an eine Stelle weit unterhalb der Sektion. */
      if (!expanded && button.getBoundingClientRect().top < 0) {
        button.scrollIntoView({ block: 'center' });
      }
    });

    wrapper.appendChild(button);
    apply();
  }

  function run() {
    try {
      build();
    } catch (e) {
      /* Eine fehlgeschlagene Verbesserung darf die Seite nicht blockieren. */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Beim Wechsel zwischen mobil und Desktop aendert sich die Zeilenzahl. */
  if (typeof MQ.addEventListener === 'function') {
    MQ.addEventListener('change', function () {
      if (text) apply();
    });
  }

  /* Theme-Editor: nach dem Neuaufbau der Sektion neu aufsetzen. */
  document.addEventListener('shopify:section:load', function () {
    text = null;
    extras = [];
    button = null;
    label = null;
    expanded = false;
    run();
  });
})();
